import { render, staticRenderFns } from "./TaskMigrationDetail.vue?vue&type=template&id=0f383fd0&"
import script from "./TaskMigrationDetail.vue?vue&type=script&lang=js&"
export * from "./TaskMigrationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports